import { VApp } from 'vuetify/lib/components/VApp';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VMenu } from 'vuetify/lib/components/VMenu';
import ClickOutside from 'vuetify/lib/directives/click-outside';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.hasReviewsList
    ? _c(
        VApp,
        { attrs: { "data-reviews-filter": "" } },
        [
          _c(_setup.ReviewsFilterTags, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _setup.isActiveTag,
                expression: "isActiveTag",
              },
            ],
            attrs: { chips: _setup.chipsFilter },
            on: { "change:filter-chip": _setup.handleChangeTagFilter },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_setup.isActiveTag,
                  expression: "!isActiveTag",
                },
              ],
            },
            [
              _setup.isMobile
                ? [
                    _c(
                      _setup.ReviewsFilterChip,
                      _vm._g(
                        {
                          attrs: {
                            selected: _setup.selected,
                            "is-active-filter": _setup.isActiveFilter,
                            "data-qa": "reviews_filter_chip",
                          },
                        },
                        {
                          "click:show": _setup.handleClickFilter,
                          "click:close": _setup.handleClickCloseFilter,
                        }
                      )
                    ),
                    _vm._v(" "),
                    _c(
                      VBottomSheet,
                      {
                        on: { "click:outside": _setup.handleClickOutside },
                        model: {
                          value: _setup.isActiveDialog,
                          callback: function ($$v) {
                            _setup.isActiveDialog = $$v
                          },
                          expression: "isActiveDialog",
                        },
                      },
                      [
                        _c(_setup.ReviewsFilterList, {
                          attrs: { "reviews-list": _setup.reviewsList },
                          on: { "click:item": _setup.handleClickItem },
                        }),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      VMenu,
                      {
                        attrs: {
                          left: "",
                          "offset-y": "",
                          "nudge-bottom": "8",
                          "max-width": "320",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      {
                                        directives: [
                                          {
                                            def: ClickOutside,
                                            name: "click-outside",
                                            rawName: "v-click-outside",
                                            value: _setup.handleClickOutside,
                                            expression: "handleClickOutside",
                                          },
                                        ],
                                        style: { maxWidth: "320px" },
                                      },
                                      on
                                    ),
                                    [
                                      _c(
                                        _setup.ReviewsFilterChip,
                                        _vm._g(
                                          {
                                            attrs: {
                                              selected: _setup.selected,
                                              "is-active-filter":
                                                _setup.isActiveFilter,
                                              "data-qa": "reviews_filter_chip",
                                            },
                                          },
                                          {
                                            "click:show":
                                              _setup.handleClickFilter,
                                            "click:close":
                                              _setup.handleClickCloseFilter,
                                          }
                                        )
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1871745620
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(_setup.ReviewsFilterList, {
                          attrs: { "reviews-list": _setup.reviewsList },
                          on: { "click:item": _setup.handleClickItem },
                        }),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }